import { Component, OnInit } from '@angular/core';
import { AlertService } from '../../_services/alert.service';
import { ApiIntegration } from '../../_services/api.integration';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { Globals } from '../../_models/globals';
import { User } from '../../_models/user';
import * as _ from "lodash";
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-create-role',
  templateUrl: './create-role.component.html',
  styleUrls: ['./create-role.component.css']
})
export class CreateRoleComponent implements OnInit {
  //roleName : string;
  groupList: any;
  roleName: any;
  statusText1: string;
  toteNameError: any;
  submitTote: any;

  constructor(private alertService: AlertService, private user: User, private http: HttpClient, private router: Router, private g: Globals, private api: ApiIntegration) {
    this.g.page = "Create Role";
    this.getAllActiveSecurityType();
  }



  getAllActiveSecurityType() {
    this.g.loaderDisplay = "display";
    this.api.getAllActiveSecurityType("1").subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.groupList = data;
      for (let i = 0; i < this.groupList.length; i++) {
        for (let j = 0; j < this.groupList[i].securityTypes.length; j++) {
          if (this.groupList[i].securityTypes[j].status === 'ACTIVE') {
            this.groupList[i].securityTypes[j].status = 'IN_ACTIVE'
          }
          this.groupList[i].securityTypes[j].enabled = false;
          if (this.groupList[i].securityTypes[j].securityCode === 'view-products' || this.groupList[i].securityTypes[j].securityCode === 'view-customers') {
            this.groupList[i].securityTypes[j].enabled = true;
            this.groupList[i].securityTypes[j].status = 'ACTIVE';
          }
        }

      }
    }, err => {
      this.g.loaderDisplay = "";
      this.alertService.error('Error', err);
    });
  }


  ngOnInit() {
  }

  sliceUPto(num) {
    if (num) {
      if (num % 2 == 0) {
        return num / 2;
      } else {
        return (num + 1) / 2;
      }
    } else {
      return 0;
    }
  }
  allStatusChange(role) {
    if (role.enableAll && role.securityTypes.length) {
      for (let i = 0; i < role.securityTypes.length; i++) {
        role.securityTypes[i].enabled = true;
        role.securityTypes[i].status = 'ACTIVE';
      }
    } else {
      for (let j = 0; j < role.securityTypes.length; j++) {
        role.securityTypes[j].enabled = false;
        role.securityTypes[j].status = 'IN_ACTIVE';
      }
    }
  }
  statusChange(action) {
    if (action.enabled) {
      action.status = 'ACTIVE';
    } else {
      action.status = 'IN_ACTIVE';
    }
  }

  submitRole() {
    this.statusText1 = "";
    if (this.roleName == '' || this.roleName === null || this.roleName === undefined || this.roleName === 'undefined') {
      this.statusText1 = 'Please enter role name';
      return false;
    }
    let request = [];
    for (let i = 0; i < this.groupList.length; i++) {
      for (let j = 0; j < this.groupList[i].securityTypes.length; j++) {
        if (this.groupList[i].securityTypes[j].status === 'ACTIVE') {
          request.push({
            "applicationSecurityTypeId": this.groupList[i].securityTypes[j].securityTypeId,
            "organizationId": 1,
            "status": "ACTIVE",
          });
        }
      }
    }
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createOrganizationRoles', {
      "organizationId": 1,
      "roleName": this.roleName,
      "settings": request,
      "status": "ACTIVE"
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Role', 'Created Sucessfully');
          this.router.navigate(['/admin/roleList']);
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          console.log(err);
        });
  }

}
